import React from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogPosts } from '../../data/blogPosts';
import './BlogLayout.css';

const BlogPost = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find(p => p.slug === slug);

  const structuredData = post ? {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": post.title,
    "datePublished": post.date,
    "dateModified": post.date,
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": `https://www.easyglobalentry.com/blog/${post.slug}`
    },
    "author": {
      "@type": "Organization",
      "name": "Easy Global Entry",
      "url": "https://easyglobalentry.com"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Easy Global Entry",
      "logo": {
        "@type": "ImageObject",
        "url": "https://easyglobalentry.com/logo192.png"
      }
    },
    "image": post.imageUrl,
    "description": post.excerpt
  } : null;

  if (!post) {
    return (
      <div className="blog-redesign" style={{ padding: '150px 20px', textAlign: 'center' }}>
        <h2 style={{ fontFamily: 'Lato, sans-serif', color: '#112E51', fontWeight: '800' }}>Post Not Found</h2>
        <p style={{ fontFamily: 'Lato, sans-serif', color: '#5B7083', margin: '16px 0 32px' }}>Sorry, the blog post you are looking for does not exist.</p>
        <Link to="/blog" className="flow-btn-primary">Back to Blog</Link>
      </div>
    );
  }

  return (
    <main className="blog-redesign">
      <Helmet>
        <title>{`${post.title} - Easy Global Entry Blog`}</title>
        <meta name="description" content={post.excerpt} />
        <link rel="canonical" href={`https://www.easyglobalentry.com/blog/${post.slug}`} />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>

      {/* Hero Image Section */}
      <section className="post-hero" style={{ backgroundImage: `url(${post.imageUrl})` }}>
        <div className="post-hero__overlay"></div>
        <div className="post-hero__inner">
          <Link to="/blog" className="post-hero__back">
            &larr; BACK TO BLOG
          </Link>
          <h1 className="post-hero__heading">{post.title}</h1>
          <div className="post-hero__meta">
            <span>{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</span>
            <span className="post-hero__dot">•</span>
            <span>By {post.author}</span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="post-content-section">
        <div className="post-content-section__inner">
          <div 
            className="post-content" 
            dangerouslySetInnerHTML={{ __html: post.content }} 
          />
          
          <div className="post-cta-box">
            <h3 className="post-cta-box__title">Ready to get your Global Entry appointment?</h3>
            <p className="post-cta-box__subtitle">Don't wait months for an interview. We scan 24/7.</p>
            <div className="post-cta-box__actions">
              <button className="post-cta-box__btn post-cta-box__btn--secondary" onClick={() => { navigate('/notify'); window.scrollTo(0,0); }}>
                Get Appointment Alerts
              </button>
              <button className="post-cta-box__btn post-cta-box__btn--primary" onClick={() => { navigate('/autobook'); window.scrollTo(0,0); }}>
                Enroll in Autobook
              </button>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default BlogPost;
